// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","main-color-active":"var(--main-color-active)","resetButton":"_3Tyifs2"};